import React, { ReactElement } from "react";
import ReactEcharts from "echarts-for-react";
import { Stack } from "@mui/system";
import { CytokineDialog } from './Dialog';
import { DrugFilteredDataType, CytoListType } from './models'
import { COLOR_PRIMARY, COLOR_DARK, COLOR_LIGHT } from './theme'
import { Typography } from "@mui/material";

export function Bar({ filteredData }: {
  filteredData:
  Array<DrugFilteredDataType>
}): ReactElement {

  const [open, setOpen] = React.useState(false);
  const [clickedCytokines, setClickedCytokines] = React.useState<Array<CytoListType>>([]);

  const handleOpen = (params: any) => {
    setClickedCytokines(filteredData.filter(v => v.drug === params.name)[0].cytokines);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (filteredData.length === 0) return <></>

  let filteredAvgEfficacy = filteredData.slice();
  filteredAvgEfficacy = filteredAvgEfficacy.sort(function (a, b) { return b.mean - a.mean; }).slice(0, 10).reverse()

  const option = {
    textStyle: {
      fontFamily: 'Lato',
      fontSize: '.9rem',
      color: COLOR_DARK
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params: any) {
        let tar = params[0].value !== '-' ? params[0] : params[1];
        return `${tar.value.toFixed(2)}%`;
      }
    },
    legend: {
      data: ['Targets all Cytokines', 'Missing Cytokines'],
      left: "right",
      top: "bottom"
    },
    grid: {
      top: 0,
      left: '0',
      right: '0%',
      bottom: '40px',
      containLabel: true,
    },
    yAxis: {
      type: 'category',
      data: filteredAvgEfficacy.map(v => v.drug),
      axisTick: { alignWithLabel: true, },
      axisLabel: { interval: 0, }
    },
    xAxis: {
      type: 'value',
      name: 'Mean Drug Efficacy',
      nameLocation: "start",
      nameTextStyle: { fontWeight: 600, verticalAlign: "top", padding: 5 },
      axisLabel: { fontWeight: 600 }
    },
    series: [
      {
        name: 'Targets all Cytokines',
        stack: 'Total',
        type: 'bar',
        color: COLOR_DARK,
        data: filteredAvgEfficacy.map(v => v.percent === 1 ? v.mean : '-'),
      },
      {
        name: 'Missing Cytokines',
        stack: 'Total',
        type: 'bar',
        color: COLOR_LIGHT,
        data: filteredAvgEfficacy.map(v => v.percent !== 1 ? v.mean : '-'),
      }
    ]
  };

  return <>
    <Typography variant="h2" sx={{ mt: 6 }}>Top 10 Drugs Associated With Search</Typography>
    <Typography variant="body1" sx={{ mb: 2 }}>Click on a bar to view cytokines targeted by drug</Typography>
    <ReactEcharts option={option} onEvents={{ click: handleOpen }} />
    <CytokineDialog
      clickedCytokines={clickedCytokines}
      open={open}
      onClose={handleClose}
    />
  </>
}
